import { useParams } from '@tanstack/react-router';
import { CreateRubricVersionFormContainer } from '../../contexts/rubrics';

export function RubricEditPage() {
  const { rubricId } = useParams({ from: '/authenticated/orgs/$orgSlug/rubrics/$rubricId/edit' });

  return (
    <div className="space-y-6">
      <header className="space-y-1.5">
        <h1 className="text-[22px] font-semibold leading-tight tracking-tight text-foreground">
          New rubric version
        </h1>
        <p className="text-[13.5px] leading-relaxed text-muted-foreground max-w-2xl">
          Versions are immutable — submitting creates a new active version.
        </p>
      </header>
      <CreateRubricVersionFormContainer rubricId={rubricId} />
    </div>
  );
}
